import * as React from 'react';

import { TableCell, TableRow } from '../../../../../../components/Table';
import { GroupTitleField } from '../../../../../../components/Field/common';

export const CommonGroupRowContainer = ({ children }: React.PropsWithChildren<{}>): React.JSX.Element => {
  return (
    <TableRow fullWidth>
      <TableCell position={0} fullWidth>
        <GroupTitleField>{children}</GroupTitleField>
      </TableCell>
    </TableRow>
  );
};
